













































































import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Autoplay, Pagination } from 'swiper'
import { PropType } from 'vue';
import { getCoverURL, getProductTopicBgColor } from '~/utils/solepro/products';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { addBasePath } from "~/helpers/addBasePath";

SwiperCore.use([Autoplay, Pagination])


import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import BrightcoveVideo from '../BrightcoveVideo.vue';
import PlayPause from './PlayPause.vue';
import { GALLERY_IMAGES_RESIZES } from '../../../utils/constants/product';
import { GenericObjectType } from '~/utils/types';
/** @TODO check all ts-ignore (transfer this to $th to fix) */
export default defineComponent({
    data() {
        return {
            isSSR: true,
            resizes: GALLERY_IMAGES_RESIZES
        }
    },
    mounted() {
        this.isSSR = false
    },
    setup(props) {
        const { app } = useContext()
        const { isBook, product } = props || {};
        const galleryImages = ref([]);
        const urlCover = ref(null);
        const activeIndex = ref(0)
        const isPlaying = ref([])

        const placeholderImage = addBasePath('/resources/productpage/solepro/product-placeholder.png');
        /**
         * @todo: handle fallback.
        */

        galleryImages.value = props?.product?.mediaGallery ?? [];
        galleryImages.value = galleryImages.value.filter(el => !el.disabled).sort((a, b) => a.position - b.position)
        const swiperProps = {
            loop: true,
            slidesPerView: 1,
            loopedSlides: 1,
            initialSlide: 0,
            centeredSlides: true,
            watchSlidesProgress: false,
            autoplay: {
                delay: 30000,
                enabled: true,
                disableOnInteraction: false
            },
            spaceBetween: 0,
            pagination: {
                clickable: true,
                el: ".product-incipit .swiper-pagination"
            },
            breakpoints: {
                1024: {
                    spaceBetween: 12
                }
            }
        }

        if (isBook && product) {
            urlCover.value = getCoverURL(product);
        }
        const noTopicColor = "#FFFFFF"; /** changed from #F7F7F7 to #FFFFFF because of the NEW PDP Figma  */
        const bgColor = ref(noTopicColor);
        useFetch(async () => {
            if (!isBook) {
                const categoriesStore = useCategoryStore();
                await categoriesStore.load()
                const categories = categoriesStore.rawCategories?.items[0].children
                bgColor.value = getProductTopicBgColor(categories, product, noTopicColor)
            } else {
                bgColor.value = "#F7F7F7"
            }
        })

        return {
            urlCover,
            galleryImages,
            swiperProps,
            placeholderImage,
            bgColor,
            activeIndex,
            isPlaying,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
            productName: props?.product?.name,
            SeoEmbedUrl: `${(app.$config as any).soleproDomain}/24orepro/${props?.product?.url_key}${props?.product?.url_suffix}`
        }

    },
    //@ts-ignore
    head() {
        const galleryImages = this.galleryImages as any[];
        const hasVideo = galleryImages?.[0] && !!galleryImages[0].video_content;
        const videoObj = hasVideo ? {
            hid: 'ld-video',
            type: 'application/ld+json',
            json: {
                "@context": "https://schema.org",
                "@type": "VideoObject",
                "name": this.productName,
                "description": `Video sul prodotto ${this.productName}.`,
                "thumbnailUrl": galleryImages[0].url.replace(this.IMAGE_STATIC_REPLACEMENT, this.IMAGE_CDN_REPLACEMENT) + (this.resizes  as GenericObjectType).desktop,
                //"uploadDate": "2024-03-31T08:00:00+08:00",
                "contentUrl": galleryImages[0].video_content.video_url,
                "embedUrl": this.SeoEmbedUrl
            }
        } : null

        return {
            script: [...(videoObj ? [videoObj] : [])]
        }
    },
    methods: {
        onVideoLoaded(index) {
            /** Workaround to play the video when on first slide. The autoplay in first slide doesn't work because a bug with swiper + brightcove lib co-existence*/
            if (index != 0) return;
            const firstSlideVideo = this.$el.querySelector(`.gallery-slide [data-real-index="0"]`).closest('.gallery-slide').querySelector('video') as HTMLVideoElement;
            firstSlideVideo.pause();
            firstSlideVideo.play && firstSlideVideo.play();
        },
        afterInit(swiper) {
            if (!swiper.$el) return;
            const bulletTimer = document.createElement('span');
            bulletTimer.classList.add('bullet-timer')
            swiper.pagination.bullets.forEach(el => {
                el.classList.add('relative')
                el.classList.add('overflow-hidden')
                el.appendChild(bulletTimer.cloneNode())
            });

            setTimeout(() => {
                swiper.update();
                setTimeout(() => {
                    //@ts-ignore
                    this.updateBulletTimer(swiper);
                }, 0)
            }, 0)


        },
        getEmbeddableURL(url) {
            if (url && url.includes('dropbox')) {
                return url.replace("dropbox.com", "dl.dropboxusercontent.com");
            } else {
                return url;
            }
        },
        updateBulletTimer(swiper) {
            if (!swiper.$el) return;
            //@ts-ignore
            const previousIndex = this.getPreviousRealIndex(swiper);
            //@ts-ignore
            const currentIndex = this.getRealIndex(swiper);
            const lastIndex = swiper.slides.length - 1;
            const isLoopToFirst = previousIndex === lastIndex && currentIndex === 0;
            const isLoopToLast = previousIndex === 0 && currentIndex === lastIndex;
            if (!swiper.pagination.bullets) return;
            if (swiper.pagination.bullets.length) {
                if (isLoopToFirst || isLoopToLast) {
                    swiper.pagination.bullets.forEach((bullet) => {
                        //@ts-ignore
                        this.handleTimerBulletAnimation(bullet, isLoopToFirst ? false : true);
                    })
                }

                swiper.pagination.bullets.forEach((bullet, index) => {
                    if (index == parseInt(currentIndex)) {
                        //@ts-ignore
                        this.addAnimation(bullet, swiper.params.autoplay.delay)
                    } else if (index < parseInt(currentIndex)) {
                        //@ts-ignore
                        this.handleTimerBulletAnimation(bullet, true)
                    } else {
                        //@ts-ignore
                        this.handleTimerBulletAnimation(bullet, false)
                    }

                })
            }
        },
        addAnimation(bullet, delay) {
            const currentBulletTimer = bullet.querySelector(".bullet-timer");
            currentBulletTimer.style.animation = `progress ${delay}ms linear forwards`;
        },
        handleTimerBulletAnimation(bullet, addClass) {
            if (addClass) {
                bullet.classList.add('prev');
            } else {
                bullet.classList.remove('prev');
            }
            bullet.offsetHeight;
            bullet.querySelector(".bullet-timer").style.animation = null;
        },
        slideChange(swiper) {
            //@ts-ignore
            this.updateBulletTimer(swiper);
            //@ts-ignore
            this.activeIndex = this.getRealIndex(swiper)

        },
        slideChangeTransitionEnd(swiper) {
            try {
                const video = swiper.slides[swiper.activeIndex].querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                    video.play && video.play();
                }
            } catch (e) { }
        },
        getRealIndex(swiper) {
            if (!swiper.$el) return 0;
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-real-index') : 0;
        },
        getPreviousRealIndex(swiper) {
            if (!swiper.$el) return 0;
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            if (swiper.realIndex > swiper.previousIndex) { // going next
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-prev-index') : 0;
            } else { //going backwards
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-next-index') : 0;
            }
        },
        togglePlay(index) {

            // Trova lo slide attivo per gestire correttamente i duplicati del loop di Swiper
            const activeSlide = this.$el.querySelector('.swiper-slide-active');
            if (!activeSlide) {
                console.warn('No active slide found');
                return;
            }

            // Cerca il video Brightcove nello slide attivo
            const brightcoveInSlide = activeSlide.querySelector('.brightcove-video');
            if (brightcoveInSlide) {
                // Usa l'API videojs direttamente sull'elemento
                //@ts-ignore
                const player = window.videojs && window.videojs(brightcoveInSlide);
                if (player) {
                    if (this.isPlaying[index]) {
                        player.pause && player.pause();
                        //@ts-ignore
                        this.onPause(index);
                    } else {
                        player.play && player.play();
                        //@ts-ignore
                        this.onPlay(index);
                    }
                    return;
                }
            }

            // Fallback: cerca l'elemento video HTML normale
            let video = activeSlide.querySelector('video') as HTMLVideoElement;
            if (video && video.tagName === 'VIDEO' && !video.classList.contains('video-js')) {
                this.isPlaying[index] ? video.pause && video.pause() : video.play && video.play();
            }
        },
        onPlay(index) {
            const isPlaying = Object.assign([], this.isPlaying);
            isPlaying[index] = true;
            this.$set(this, 'isPlaying', isPlaying);
        },
        onPause(index) {
            const isPlaying = Object.assign([], this.isPlaying);
            isPlaying[index] = false;
            this.$set(this, 'isPlaying', isPlaying);
        }
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isBook: {
            type: Boolean
        }
    },
    components: {
        SwiperSlide,
        Swiper,
        BrightcoveVideo,
        PlayPause
    },
})
